import React from 'react';
import { withStyles } from "@mui/styles";
import { Grid, Typography } from '@mui/material';

import en from "../../i18n/English/Policies/refund.json";
import hi from "../../i18n/Hindi/Policies/refund.json";
import kn from "../../i18n/Kannada/Policies/refund.json";
import ma from "../../i18n/Marathi/Policies/refund.json";
import gu from "../../i18n/Gujarati/Policies/refund.json";
import { useLanguage } from "../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'Refund Policy | Secure, Transparent Transactions | TradeBoss',
    description: 'Learn about TradeBoss refund policy for trading & subscriptions. We ensure secure payments and transparent refunds for all investors.',
    canonical: 'https://tradeboss.co/refund_policy',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'tradeboss refund policy, refund trading subscription, refund demat account, returns policy, cancellation policy trading service'
        }
    }
}
const styles = theme => ({
    heading: {
        textTransform: 'none !important',
        color: '#000000 !important',
   fontFamily: 'Inter500 !important',
        fontSize: 'calc(24px + var(--font-delta)) !important',
        marginBlockStart: 0,
        marginBlockEnd: 0,
        fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter500 !important',
            fontSize: 'calc(20px + var(--font-delta)) !important',
        }
    },
    p_body: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(16px + var(--font-delta)) !important',
        lineHeight: "22px !important",
        "@media only screen and (max-device-width: 480px)": {
            fontFamily: 'Inter400 !important',
            fontSize: 'calc(14px + var(--font-delta)) !important',
            lineHeight: "20px !important",
        }
    },
})

const Refund_policy = ({ classes }) => {
    const { language } = useLanguage();
    const translations = { en, hi, kn, ma, gu };
    const t = translations[language];
    return (
        <div style={{ height: 'auto', padding: '0px 0px 20px 0px' }}>
            <DocumentMeta {...meta} />
            <Grid sx={{ padding: '20px 0px 40px 0px' }}>
                <h1 className={classes.heading}>
                   {t.heading}
                </h1>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.subtitle}
                </Typography>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 40px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    <ul>
                        <li>{t.points[0]}</li>
                        <li>{t.points[1]}</li>
                        <li>{t.points[2]}</li>
                        <li>{t.points[3]}</li>
                    </ul>
                </Typography>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {language === "en" && `${t.text}`} <b>{t.text4}</b>{t.text5}
                </Typography>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.text1}
                </Typography>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.text2}
                </Typography>
                <Typography className={classes.p_body} sx={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    <b>{t.note}</b>{t.text3}
                </Typography>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(Refund_policy);